import LtsLayout from 'src/onboarding/layouts/lts';

// import AnalysisLayout from './layouts/analysis/layout';
import AnalyzingAnswersPage from './pages/analyzing-answers/page';
// import AnalysisPage from './pages/analysis/page';
// import WebUpsale from './pages/webUpsale';
import WebUpsaleFirst from './pages/webUpsale/components/WebUpsaleFirst';
// import WebUpsaleSecond from './pages/webUpsale/components/WebUpsaleSecond';
import WebUpsaleThird from './pages/webUpsale/components/WebUpsaleThird';
import WebUpsaleFourth from './pages/webUpsale/components/WebUpsaleFourth';
import WebUpsaleFifth from './pages/webUpsale/components/WebUpsaleFifth';
import TermsOfUse from './pages/terms-of-use';
import PrivacyPolicy from './pages/privacy-policy';
import LegalLayout from './layouts/legal';
import StartingPointPage from './pages/starting-point';
import YourPowerPage from './pages/your-power';
import HiddenAllyPage from './pages/hidden-ally';
import TinyWinsPage from './pages/tiny-wins';
import BalanceEverythingPage from './pages/balance-everything';
import FuelsProgressPage from './pages/fuels-progress';

import GenderPage from "./pages/gender"
import BornPage from "./pages/born"
import NamePage from "./pages/name"
import HeightPage from "./pages/height"
import WeightPage from "./pages/weight"
import TransitionFirst from "./pages/transition/transitionFirst"
import LoosGoalPage from "./pages/loos-goal"
import IdealWeightPage from "./pages/ideal-weight"
import MotivationPage from "./pages/motivation"
import WhenPage from "./pages/when"
import GoalPage from "./pages/goal"
import GoalSecondPage from './pages/goal/goalSecond/GoalSecond'
import EmailPage from "./pages/email"
import EmailAfterPaymentPage from "./pages/email-after-payment"
import TransitionSecond from "./pages/transition/transitionSecond"
import LtsvPhotoExamplePage from "./pages/lts-photo-example"
import MealsCountPage from "./pages/meals-count"
import PrepareMealsPage from "./pages/prepare-meals"
import DailyDrinkPage from "./pages/daily-drink"
import TransitionThird from "./pages/transition/transitionThird"
import CrabDensePage from "./pages/crab-dense"
import PreferencesPage from "./pages/preferences"
import HabitsPage from "./pages/habits"
import ExcludePage from "./pages/exclude"
import TypicalLunchPage from "./pages/typical-lunch"
import VegetableIntakePage from "./pages/vegetable-intake"
import TransitionFourth from "./pages/transition/transitionFourth"
import HealthConcernsPage from "./pages/health-concerns"
import WorkSchedulePage from "./pages/work-schedule"
import YourLifestylePage from "./pages/your-lifestyle"
import GoForWalksPage from "./pages/go-for-walks"
import WorkOutPage from "./pages/work-out"
import SleepPerNightPage from "./pages/sleep-per-night"
import ImproveYourSleepPage from "./pages/improve-your-sleep"
import TransitionSeventh from "./pages/transition/transitionSeventh"
import ChangeMotivationPage from "./pages/change-motivation"
import StatementPage from "./pages/statement"
import AtThisMomentPage from "./pages/at-this-moment"
import LtsResultPage from "./pages/lts-result"
import PersonalPlanPage from "./pages/personal-plan/index"
import WebUpsaleThirdNew from "./pages/web-upsale/webUpsaleThird"
import WebUpsaleFourthNew from "./pages/web-upsale/webUpsaleFourth"
import MainLayout from "./layouts/main/layout";
import TransitionLayout from "./layouts/transition";
import GoalRightNowPage from './pages/goal-right-now';
import MostDifficultPage from './pages/most-difficult'
import UsualBreakfastPage from './pages/usual-breakfast'
import AdditionalGoalsPage from './pages/additional-goals'
import TrustedPage from './pages/trusted'
import EatHoursPage from './pages/eat-hours'
import PersonalSummaryPage from './pages/personal-summary'
import SnackCravingsPage from './pages/snack-cravings'
import TypicallyTriggersPage from './pages/typically-triggers'
import StatementTenthPage from './pages/statement/statementTenth'
import StatementSecondPage from './pages/statement/statementSecond'
import StatementThirdPage from './pages/statement/statementThird'
import StatementFourthPage from './pages/statement/statementFourth'
import NutritionHabitsPage from './pages/nutrition-habits'
import TransitionFifth from './pages/transition/transitionFifth';
import TopicOfWeightLossPage from './pages/topic-of-weight-loss'
import CaloriesRelationshipPage from './pages/calories-relationship'
import TransitionSixth from './pages/transition/transitionSixth'
import StatementFifthPage from './pages/statement/statementFifth'
import StatementSixthPage from './pages/statement/statementSixth'
import StatementSeventhPage from './pages/statement/statementSeventh'
import StartTrainingPage from './pages/start-training'
import ChildrenPage from './pages/children'
import NutrientsPage from './pages/nutrients'
import TransitionEighth from './pages/transition/transitionEighth';
import StatementEighthPage from './pages/statement/statementEighth';
import StatementNinthPage from './pages/statement/statementNinth';
import AlmostDonePage from './pages/almost-done'
import ThinkOfIdealWeightPage from './pages/think-of-ideal-weight'
import StrugglePage from './pages/struggle'
import UncertainPage from './pages/uncertain'
import EatingHabitsPage from './pages/eating-habits'
import EnergyLevelPage from './pages/energy-level'
import ThoughtsPage from './pages/thoughts'
import BirthDatePage from './pages/birth-date'
import AnalyzeBodyPage from './pages/analyze-body'
import FullBodyPhotoPage from './pages/full-body-photo'
import BeforeAfterPage from './pages/before-after';
import CompletelySafePage from './pages/completely-safe';
import UpsaleWithoutTrial from './pages/webUpsale/components/UpsaleWithoutTrial';
import TrustedSecondPage from './pages/trusted-2'
import ThisWillWorkPage from './pages/this-will-work'
import BodyTypePage from './pages/body-type'
import IndividualApproachPage from './pages/individual-approach'
import GuideYouPage from './pages/guide-you'
import NoMoreCravingsPage from './pages/no-more-cravings';
import TakePicturesPage from './pages/take-pictures';
import WithoutExercisePage from './pages/without-exercise';
import NeverQuitsPage from './pages/never-quits'
import LastPeriodPage from './pages/last-period'
import YourBiggestConcernPage from './pages/your-biggest-concern'
import FeelLikePage from './pages/feel-like';
import TrialPricePage from './pages/trial-price';

//how-many-calories
import HowManyCaloriesFirst from './pages/how-many-calories/howManyCaloriesFirst';
import HowManyCaloriesSecond from './pages/how-many-calories/howManyCaloriesSecond';
import HowManyCaloriesThird from './pages/how-many-calories/howManyCaloriesThird';
import HowManyCaloriesFourth from './pages/how-many-calories/howManyCaloriesFourth';
import HowManyCaloriesFifth from './pages/how-many-calories/howManyCaloriesFifth';
import YouGuessedPage from './pages/you-guessed';
import HowManyCaloriesSixth from './pages/how-many-calories/howManyCaloriesSixth';
import HowManyCaloriesSeventh from './pages/how-many-calories/howManyCaloriesSeventh';
import HowManyCaloriesEighth from './pages/how-many-calories/howManyCaloiesEighth';
import HowManyCaloriesNinth from './pages/how-many-calories/howManyCaloriesNinth';
import HowManyCaloriesTenth from './pages/how-many-calories/howManyCaloriesTenth';
import EnjoyFullPlatesPage from './pages/enjoy-full-plates';

import PrelandPage from './pages/preland';

import UsedGlp from './pages/used-glp';
import CurrentlyTaking from './pages/currently-taking';
import SemaglutideDose from './pages/semaglutide-dose';
import HowFamiliar from './pages/how-familiar';
import GlpDiet from './pages/glp-diet';
import SideEffects from './pages/side-effects';
import NoticedMuscle from './pages/noticed-muscle';
import GlpReviews from './pages/glp-reviews';

import PersonalPlanSecond from './pages/personal-plan-2';
import EmailSecond from './pages/email-2';

import BestApp from './pages/best-app';

import DietFamiliarity from './pages/diet-familiarity';
import BodyAreas from './pages/body-areas';
import MeatRelationship from './pages/meat-relationship';
import IdealWeightTime from './pages/ideal-weight-time';
import WeightChange from './pages/weight-change';
import EnergyLevels from './pages/energy-levels';
import DailyActivity from './pages/daily-activity';
import MainReason from './pages/main-reason';
import Dairy from './pages/dairy';
import MealTransition from './pages/meal-transition';

import FoodShopping from './pages/food-shopping';
import BudgetPriority from './pages/budget-priority';
import IngredientPreference from './pages/ingredient-preference';
import BudgetTransition from './pages/budget-transition';
import Snacks from './pages/snacks';
import Breakfast from './pages/breakfast';

import Analyzing from './pages/analyzing';
import AnalyzingSecond from './pages/analyzing';
import AnalyzingThird from './pages/analyzing';
import AnalyzingFourth from './pages/analyzing';

import PersonalPlanThird from './pages/personal-plan-3';

import AnalyzingBody from './pages/analyzing-body';
import CalorieNeeds from './pages/calorie-needs';
import DailySteps from './pages/daily-steps';

import CalorieNeedsCorrected from './pages/calorie-needs-corrected';
import ChooseBreakfast from './pages/choose-breakfast';
import ChooseLunch from './pages/choose-lunch';
import ChooseSnack from './pages/choose-snack';
import ChooseDinner from './pages/choose-dinner';
import CookingTime from './pages/cooking-time';
import GroceryBudget from './pages/grocery-budget';
import BuildingMealPlan from './pages/building-meal-plan';

import AnalyzingActivity from './pages/analyzing-activity';

import MindsetIntro from './pages/mindset-intro';
import EatLessMoveMore from './pages/eat-less-move-more';
import CalorieTracking from './pages/calorie-tracking';
import NutritionTransition from './pages/nutrition-transition';
import FavoriteFoods from './pages/favorite-foods';
import DislikeDiets from './pages/dislike-diets';
import RestartAfterSlip from './pages/restart-after-slip';
import NoDietsTRansition from './pages/no-diets-transition';
import FastingExperience from './pages/fasting-experience';
import FastingDetails from './pages/fasting-details';
import FastingTransition from './pages/fasting-transition';
import SpeedFuelsSuccess from './pages/speed-fuels-success';
import DietsRestrictions from './pages/diet-restrictions';
import WeightlossApproach from './pages/weightloss-approach';
import MealPlanExperience from './pages/mealplan-experience';
import OffplanBehavior from './pages/offplan-behavior';
import FlexiblePlanTransition from './pages/flexible-plan-transition';

import PersonalPlanFourth from './pages/personal-plan-4';

import GoalMain from './pages/goal-main';
import GoalWeightlossReason from './pages/goal-weightloss-reason';
import GoalAdditional from './pages/goal-additional';
import WeightlossExperience from './pages/weightloss-experience';
import WeightlossChallenges from './pages/weightloss-challenges';
import WeightGainReason from './pages/weight-gain-reason';
import PreviousAttempt from './pages/previous-attempt';
import WhatsDifferentThisTime from './pages/whats-different-this-time';
import SuccessVisualization from './pages/success-visualization';
import CalorieTrackingBefore from './pages/calorie-tracking-before';
import CalorieTrackingMethod from './pages/calorie-tracking-method';
import CalorieTrackingApp from './pages/calorie-tracking-app';
import CalorieDifficulty from './pages/calorie-difficulty';
import CalorieEducation from './pages/calorie-education';
import StayOnTrack from './pages/stay-on-track';
import GoalMotivation from './pages/goal-motivation'
import StartEmotions from './pages/start-emotions'
import UsageTime from './pages/usage-time'
import WeekendsHard from './pages/weekends-hard'
import TriggersEating from './pages/triggers-eating'
import ImproveHabits from './pages/improve-habits'
import LoggingHabits from './pages/logging-habits'
import ActivityPlan from './pages/activity-plan'
import ProgressTracking from './pages/progress-tracking'
import Rewards from './pages/rewards'
import WorkHours from './pages/work-hours'
import SocialEating from './pages/social-eating'
import StayMotivated from './pages/stay-motivated'
import WeekendMore from './pages/weekend-more'
import WeekendDays from './pages/weekend-days'

import FoodRelationship from './pages/food-relationship';
import SnackTime from './pages/snack-time';
import MorningHabits from './pages/morning-habits';
import SelfEvaluation from './pages/self-evaluation';
import Barriers from './pages/barriers';
import FoodMythsSweets from './pages/food-myths-sweets';
import FoodMythsPizza from './pages/food-myths-pizza';
import FoodMythsEvening from './pages/food-myths-evening';
import HealthyEating from './pages/healthy-eating';
import EmotialEating from './pages/emotional-eating';

import CalorieFreeTransition from './pages/calorie-free-transition';
import BalanceTransition from './pages/balance-transition';
import FlexibleMealTransition from './pages/flexible-meal-transition';

//yazio-transitions
import AccountedTransition from './pages/yazio-transitions/accounted-transition';
import BePreparedTransition from './pages/yazio-transitions/be-prepared-transition';
import BusyParentsTransition from './pages/yazio-transitions/busy-parents-transition';
import CalorieTrackingTransition from './pages/yazio-transitions/calorie-tracking-transition';
import CompletelyNormalTransition from './pages/yazio-transitions/completely-normal-transition';
import EnvironmentTransition from './pages/yazio-transitions/environment-transition';
import ExcellentNewsTransition from './pages/yazio-transitions/excellent-news-transition';
import ExcellentTransition from './pages/yazio-transitions/excellent-transition';
import FindTimeTransition from './pages/yazio-transitions/find-time-transition';
import GoalFirstStepTransition from './pages/yazio-transitions/goal-first-step-transition';
import GoodJobTransition from './pages/yazio-transitions/good-job-transition';
import MotivationTransition from './pages/yazio-transitions/motivation-transition';
import NoStarvingTransition from './pages/yazio-transitions/no-starving-transition';
import NormalTransition from './pages/yazio-transitions/normal-transition';
import NotAloneTransition from './pages/yazio-transitions/not-alone-transition';
import RememberGoalsTransition from './pages/yazio-transitions/remember-goals-transition';
import SelfMadeTransition from './pages/yazio-transitions/self-made-transition';
import SimpleIdeaTransition from './pages/yazio-transitions/simple-idea-transition';
import SmallStepsTransition from './pages/yazio-transitions/small-steps-transition';
import SuccessPathTransition from './pages/yazio-transitions/success-path-transition';
import ThankYouTransition from './pages/yazio-transitions/thank-you-transition';
import WeHelpTransition from './pages/yazio-transitions/we-help-transition';
import WeekendsSupportTransition from './pages/yazio-transitions/weekends-support-transition';
import WeightlossSupportTransition from './pages/yazio-transitions/weightloss-support-transition';
import YouCanTooTransition from './pages/yazio-transitions/you-can-too-transition';
import RecipesTransition from './pages/yazio-transitions/recipes-transition';
import BiggerCommunityTransition from './pages/yazio-transitions/bigger-community-transition';

import UnderstandYourBody from './pages/understand-your-body';
import PersonalPlanMetabolism from './pages/personal-plan-metabolism';
import UpsaleNutritionBundle from './pages/webUpsale/components/upsale-nutrition-bundle';

import UpsaleDynamic from './pages/upsale-dynamic';
import PersonalPlanDynamic from './pages/dynamic-personal-plan';

import FaceScanPhoto from './pages/face-scan';
import FaceScanAnimation from './pages/face-scan-animation';
import FaceScanId from './pages/face-scan-id';

import PaywallPage from './pages/paywall';

export const backupFlow = [
  'gender',
  'born',
  'name',
  'height',
  'weight',
  'loos-goal',
  'ideal-weight',
  'motivation',
  'when',
  'goal',
  'email',
  'meals-count',
  'prepare-meals',
  'daily-drink',
  'crab-dense',
  'preferences',
  'habits',
  'exclude',
  'typical-lunch',
  'vegetable-intake',
  'health-concerns',
  'work-schedule',
  'your-lifestyle',
  'go-for-walks',
  'work-out',
  'sleep-per-night',
  'improve-your-sleep',
  'change-motivation',
  'statement',
  'at-this-moment',
  'personal-plan',
  'web-upsale-4',
];

export const components = {
    "understand-your-body": UnderstandYourBody,
    "weightloss-support-transition": WeightlossSupportTransition,
    "you-can-too-transition": YouCanTooTransition,
    "motivation-transition": MotivationTransition,
    "calorie-tracking-transition": CalorieTrackingTransition,
    "simple-idea-transition": SimpleIdeaTransition,
    "no-starving-transition": NoStarvingTransition,
    "success-path-transition": SuccessPathTransition,
    "excellent-news-transition": ExcellentNewsTransition,
    "we-help-transition": WeHelpTransition,
    "normal-transition": NormalTransition,
    "remember-goals-transition": RememberGoalsTransition,
    "goal-first-step-transition": GoalFirstStepTransition,
    "good-job-transition": GoodJobTransition,
    "excellent-transition": ExcellentTransition,
    "completely-normal-transition": CompletelyNormalTransition,
    "not-alone-transition": NotAloneTransition,
    "small-steps-transition": SmallStepsTransition,
    "environment-transition": EnvironmentTransition,
    "busy-parents-transition": BusyParentsTransition,
    "find-time-transition": FindTimeTransition,
    "self-made-transition": SelfMadeTransition,
    "be-prepared-transition":BePreparedTransition,
    "thank-you-transition": ThankYouTransition,
    "weekends-support-transition": WeekendsSupportTransition,
    "accounted-transition": AccountedTransition,
    "recipes-transition": RecipesTransition,
    "bigger-community-transition": BiggerCommunityTransition,

    "calorie-free-transition": CalorieFreeTransition,
    "balance-transition": BalanceTransition,
    "flexible-meal-transition": FlexibleMealTransition,
    "goal-main": GoalMain,
    "goal-weightloss-reason": GoalWeightlossReason,
    "goal-additional": GoalAdditional,
    "weightloss-experience": WeightlossExperience,
    "weightloss-challenges": WeightlossChallenges,
    "weight-gain-reason": WeightGainReason,
    "previous-attempt": PreviousAttempt,
    "whats-different-this-time": WhatsDifferentThisTime,
    "success-visualization": SuccessVisualization,
    "calorie-tracking-before": CalorieTrackingBefore,
    "calorie-tracking-method": CalorieTrackingMethod,
    "calorie-tracking-app": CalorieTrackingApp,
    "calorie-difficulty": CalorieDifficulty,
    "calorie-education": CalorieEducation,
    "stay-on-track": StayOnTrack,
    "goal-motivation": GoalMotivation,
    "start-emotions": StartEmotions,
    "usage-time": UsageTime,
    "weekends-hard": WeekendsHard,
    "triggers-eating": TriggersEating,
    "improve-habits": ImproveHabits,
    "logging-habits": LoggingHabits,
    "activity-plan": ActivityPlan,
    "progress-tracking": ProgressTracking,
    "rewards": Rewards,
    "work-hours": WorkHours,
    "social-eating": SocialEating,
    "stay-motivated": StayMotivated,
    "weekend-more": WeekendMore,
    "weekend-days": WeekendDays,


    "food-relationship": FoodRelationship,
    "snack-time": SnackTime,
    "morning-habits": MorningHabits,
    "self-evaluation": SelfEvaluation,
    "barriers": Barriers,
    "food-myths-sweets": FoodMythsSweets,
    "food-myths-pizza": FoodMythsPizza,
    "food-myths-evening": FoodMythsEvening,
    "healthy-eating": HealthyEating,
    "emotional-eating": EmotialEating,
    "mindset-intro": MindsetIntro,
    "speed-fuels-success": SpeedFuelsSuccess,
    "diet-restrictions": DietsRestrictions,
    "weightloss-approach": WeightlossApproach,
    "eat-less-move-more": EatLessMoveMore,
    "calorie-tracking": CalorieTracking,
    "nutrition-transition": NutritionTransition,
    "favorite-foods": FavoriteFoods,
    "dislike-diets": DislikeDiets,
    "restart-after-slip": RestartAfterSlip,
    "no-diets-transition": NoDietsTRansition,
    "fasting-experience": FastingExperience,
    "fasting-details": FastingDetails,
    "fasting-transition": FastingTransition,
    "mealplan-experience": MealPlanExperience,
    "offplan-behavior": OffplanBehavior,
    "flexible-plan-transition": FlexiblePlanTransition,
    "analyzing-activity": AnalyzingActivity,
    "calorie-needs-corrected": CalorieNeedsCorrected,
    "choose-breakfast": ChooseBreakfast,
    "choose-lunch": ChooseLunch,
    "choose-snack": ChooseSnack,
    "choose-dinner": ChooseDinner,
    "cooking-time" : CookingTime,
    "grocery-budget": GroceryBudget,
    "building-meal-plan": BuildingMealPlan,
    "daily-steps": DailySteps,
    "analyzing-body": AnalyzingBody,
    "calorie-needs": CalorieNeeds,
    "analyzing": Analyzing,
    "analyzing-2": AnalyzingSecond,
    "analyzing-3": AnalyzingThird,
    "analyzing-4": AnalyzingFourth,
    "food-shopping": FoodShopping,
    "budget-priority": BudgetPriority,
    "ingredient-preference": IngredientPreference,
    "budget-transition": BudgetTransition,
    "snacks": Snacks,
    "breakfast": Breakfast,
    "diet-familiarity": DietFamiliarity,
    "body-areas": BodyAreas,
    "meat-relationship": MeatRelationship,
    "ideal-weight-time": IdealWeightTime,
    "weight-change": WeightChange,
    "energy-levels": EnergyLevels,
    "daily-activity": DailyActivity,
    "main-reason": MainReason,
    "dairy": Dairy,
    "meal-transition": MealTransition,
    "best-app": BestApp,
    "email-2": EmailSecond,
    "used-glp": UsedGlp,
    "currently-taking": CurrentlyTaking,
    "semaglutide-dose": SemaglutideDose,
    "how-familiar": HowFamiliar,
    "glp-diet": GlpDiet,
    "glp-reviews": GlpReviews,
    "side-effects": SideEffects,
    "noticed-muscle": NoticedMuscle,
    "preland": PrelandPage,
    "now-many-calories-1": HowManyCaloriesFirst,
    "how-many-calories-2": HowManyCaloriesSecond,
    "how-many-calories-3": HowManyCaloriesThird,
    "how-many-calories-4": HowManyCaloriesFourth,
    "how-many-calories-5": HowManyCaloriesFifth,
    "you-guessed": YouGuessedPage,
    "how-many-calories-6": HowManyCaloriesSixth,
    "now-many-calories-7": HowManyCaloriesSeventh,
    "how-many-calories-8": HowManyCaloriesEighth,
    "how-many-calories-9": HowManyCaloriesNinth,
    "how-many-calories-10": HowManyCaloriesTenth,
    "enjoy-full-plates": EnjoyFullPlatesPage,
    "gender": GenderPage,
    "trusted": TrustedPage,
    "trusted-2": TrustedSecondPage,
    'birth-date': BirthDatePage,
    "born": BornPage,
    "name": NamePage,
    "body-type": BodyTypePage,
    "height": HeightPage,
    "weight": WeightPage,
    "analyze-body": AnalyzeBodyPage,
    "full-body-photo": FullBodyPhotoPage,
    "transition-1": TransitionFirst,
    "goal-right-now": GoalRightNowPage,
    "this-will-work": ThisWillWorkPage,
    "most-difficult": MostDifficultPage,
    "usual-breakfast": UsualBreakfastPage,
    "loos-goal": LoosGoalPage,
    "personal-summary": PersonalSummaryPage,
    "eat-hours": EatHoursPage,
    "additional-goals": AdditionalGoalsPage,
    "last-period": LastPeriodPage,
    "your-biggest-concern": YourBiggestConcernPage,
    "feel-like": FeelLikePage,
    "ideal-weight": IdealWeightPage,
    "motivation": MotivationPage,
    "when": WhenPage,
    'goal': GoalPage,
    'goal-2': GoalSecondPage,
    "completely-safe": CompletelySafePage,
    "email": EmailPage,
    "email-after-payment": EmailAfterPaymentPage,
    "individual-approach": IndividualApproachPage,
    "transition-2": TransitionSecond,
    "before-after": BeforeAfterPage,
    "lts-photo-example": LtsvPhotoExamplePage,
    "face-scan": FaceScanPhoto,
    "face-scan-animation": FaceScanAnimation,
    "face-scan-id": FaceScanId,
    "meals-count": MealsCountPage,
    "prepare-meals": PrepareMealsPage,
    "guide-you": GuideYouPage,
    "daily-drink": DailyDrinkPage,
    "snack-cravings": SnackCravingsPage,
    "typically-triggers": TypicallyTriggersPage,
    "statement-10": StatementTenthPage,
    "statement-2": StatementSecondPage,
    "statement-3": StatementThirdPage,
    "statement-4": StatementFourthPage,
    "transition-3": TransitionThird,
    "crab-dense": CrabDensePage,
    "preferences": PreferencesPage,
    "habits": HabitsPage,
    "exclude": ExcludePage,
    "typical-lunch": TypicalLunchPage,
    "vegetable-intake": VegetableIntakePage,
    "transition-4": TransitionFourth,
    "transition-5": TransitionFifth,
    "topic-of-weight-loss": TopicOfWeightLossPage,
    "calories-relationship": CaloriesRelationshipPage,
    "transition-6": TransitionSixth,
    "health-concerns": HealthConcernsPage,
    "nutrition-habits": NutritionHabitsPage,
    "statement-5": StatementFifthPage,
    "statement-6": StatementSixthPage,
    "statement-7": StatementSeventhPage,
    "work-schedule": WorkSchedulePage,
    "start-training": StartTrainingPage,
    "without-exercise": WithoutExercisePage,
    "your-lifestyle": YourLifestylePage,
    "go-for-walks": GoForWalksPage,
    "work-out": WorkOutPage,
    "sleep-per-night": SleepPerNightPage,
    "improve-your-sleep": ImproveYourSleepPage,
    "children": ChildrenPage,
    "transition-7": TransitionSeventh,
    "nutrients": NutrientsPage,
    "transition-8": TransitionEighth,
    "take-pictures": TakePicturesPage,
    "statement-8": StatementEighthPage,
    "statement-9": StatementNinthPage,
    "almost-done": AlmostDonePage,
    "think-of-ideal-weight": ThinkOfIdealWeightPage,
    "struggle": StrugglePage,
    "uncertain": UncertainPage,
    "eating-habits": EatingHabitsPage,
    "no-more-cravings": NoMoreCravingsPage,
    "energy-level": EnergyLevelPage,
    "never-quits": NeverQuitsPage,
    "thoughts": ThoughtsPage,
    "change-motivation": ChangeMotivationPage,
    "statement": StatementPage,
    "at-this-moment": AtThisMomentPage,
    "lts-result": LtsResultPage,
    "personal-plan-2": PersonalPlanSecond,
    "personal-plan-3": PersonalPlanThird,
    "personal-plan-4": PersonalPlanFourth,
    "personal-plan-metabolism": PersonalPlanMetabolism,
    'analyzing-answers': AnalyzingAnswersPage,
    "trial-price": TrialPricePage,
    "personal-plan": PersonalPlanPage,
    "personal-plan-dynamic": PersonalPlanDynamic,
    "paywall": PaywallPage,
    "web-upsale-1": WebUpsaleFirst,
    'web-upsale-3': WebUpsaleThird,
    'web-upsale-4': WebUpsaleFourth,
    'web-upsale-5': WebUpsaleFifth,
    'upsale-without-trial': UpsaleWithoutTrial,
    'upsale-nutrition-bundle': UpsaleNutritionBundle,
    'upsale-dynamic': UpsaleDynamic,
    'terms-of-use': TermsOfUse,
    'privacy-policy': PrivacyPolicy,
}

export const layouts = {
    MainLayout,
    LegalLayout,
    TransitionLayout,
    LtsLayout,
}

export const transitionPages = [
  'transition-1',
  'transition-2',
  'transition-3',
  'transition-4',
  'transition-5',
  'transition-6',
  'transition-7',
  'transition-8'
];
